


































































































































































import { Component } from 'vue-property-decorator';
import { Base } from '../common/base';
import {
  OpenRepairOrderViewModel,
  VoiceCallModel,
  CallType,
} from '@/models/fixedops/repairorder';
import { MetadataType, MetadataKeyIdentifier } from '@/enums/enums';
import { voiceCallService, callTypeService, customerService } from '@/shared';

@Component({
  watch: {
    customerInformation(newVal, oldVal) {
      this.getCustomerInfo(newVal);
    },
  },
  props: ['customerInformation'],
})
export default class VoiceConversationComponent extends Base {
  public customerInfo: OpenRepairOrderViewModel = {};
  public callTypes: CallType[] = [];
  public isLoaded: boolean = false;
  public disableCallButton: boolean = false;
  public isCallCustomerLoading: boolean = false;

  public mounted(): void {
    this.getCallTypes();
  }

  public close(): void {
    this.$emit('onClose');
  }

  public async getCallTypes(): Promise<void> {
    try {
      this.disableCallButton = true;
      const response = await callTypeService.getCallTypesAsync();
      this.callTypes = response.results;
    } finally {
      this.disableCallButton = false;
    }
  }

  public async makeCall(): Promise<void> {
    try {
      this.disableCallButton = true;
      const voiceCallModel: VoiceCallModel = {
        callType: this.customerInfo.callType,
        customerKey: this.customerInfo.customerKey,
        customerName: this.customerInfo.customerName,
        recordIdentifier: MetadataType[MetadataType.RO],
        recordKey: this.customerInfo.repairOrderNumber,
        recordKeyIdentifier:
          MetadataKeyIdentifier[MetadataKeyIdentifier.RepairOrderNumber],
        toNumber: this.customerPhoneNumber(),
        vin: this.customerInfo.vin,
      };

      if (!voiceCallModel.toNumber || voiceCallModel.toNumber === '0') {
        this.showAlert(
          false,
          this.$t('voiceConversation.alertcustomerPhoneCanNotEmpty')
        );
        return;
      }

      const response = await voiceCallService.makeOutboundCallAsync(
        voiceCallModel
      );
      if (response.isSuccess) {
        this.showAlert(true, response.message);
      } else {
        this.showAlert(
          false,
          this.$t('voiceConversation.alertSomeErrorOccurredWhileMakingCall')
        );
      }
      this.close();
    } finally {
      this.disableCallButton = false;
    }
  }

  public customerPhoneNumber(): string {
    let pNumber = '';
    switch (this.customerInfo.callTo) {
      case 'home': {
        pNumber = this.customerInfo.customerPhoneNumber;
        break;
      }
      case 'cellphone': {
        pNumber = this.customerInfo.cellPhone;
        break;
      }
      case 'businessPhone': {
        pNumber = this.customerInfo.businessPhone;
        break;
      }
      case 'other': {
        pNumber = this.customerInfo.otherNumber;
        break;
      }
      default: {
        pNumber = this.customerInfo.customerPhoneNumber;
      }
    }
    return pNumber;
  }

  public async getCustomerInfo(model: OpenRepairOrderViewModel): Promise<void> {
    try {
      this.isCallCustomerLoading = true;
      this.isLoaded = false;

      const response = await customerService.getCustomerInfoAsync(
        model.customerKey
      );
      const keys = Object.keys(response);
      keys.forEach((key) => {
        model[key] = response[key];
      });

      this.customerInfo = model;
      if (this.callTypes.length > 0) {
        this.customerInfo.callType = this.callTypes[0].id;
      }

      this.customerInfo.callTo = 'home';
      this.customerInfo.otherNumber = '';
    } catch (e) {
      this.close();
    } finally {
      this.isLoaded = true;
      this.isCallCustomerLoading = false;
    }
  }
}
